import gql from 'graphql-tag';

export const QUALIFICATION_MUTATION = gql`
  mutation ($qualification: QualificationInput!) {
    saveQualification (qualification: $qualification) {
      id
      name
      response
      stateCode
      statusCode
      autoPopulateDwellingType
      createdOn
    }
  }
`;
